import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import {
  Button,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter
} from '../ui';
import { ExclamationTriangleIcon } from '../ui/Icons';
import { getRecordPreviewLabel } from '../../utils/recordPreviewLabel';

/**
 * DeleteModal - Delete confirmation modal component
 * Extracted from GenericFormsPage for better maintainability
 */
const DeleteModal = ({
  // State
  isOpen,
  selectedRecord,
  isLoading,
  entityName,
  
  // Configuration
  tableColumns,
  labels,
  
  // Callbacks
  onClose,
  onConfirm
}) => {
  const { theme } = useTheme();

  if (!isOpen || !selectedRecord) {
    return null;
  }

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      size="sm"
    >
      <ModalHeader onClose={onClose}>
        <div className="flex items-center">
          <div className={`p-2 ${theme.colors.danger} rounded-lg mr-3`}>
            <ExclamationTriangleIcon className={`w-6 h-6 ${theme.text.inverse}`} />
          </div>
          <ModalTitle>{labels.deleteTitle}</ModalTitle>
        </div>
      </ModalHeader>
      <ModalContent>
        <p className={`${theme.text.secondary} mb-4`}>
          {labels.deleteConfirmText}
        </p>
        <div className={`p-4 ${theme.colors.background} rounded-lg`}>
          <div className={`text-sm ${theme.text.primary} font-medium`}>
            {getRecordPreviewLabel(selectedRecord, tableColumns, entityName)}
          </div>
        </div>
      </ModalContent>
      <ModalFooter>
        <div className="flex space-x-3">
          <Button
            onClick={onClose}
            variant="outline"
            className="flex-1"
          >
            {labels.cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
            variant="danger"
            className="flex-1"
          >
            {labels.deleteText}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
